import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
class Search extends Component {
    constructor() {
        super(...arguments);
        this.handleChange = (e) => {
            const { target: { value }, } = e;
            this.props.onChange(value);
        };
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "relative" },
            React.createElement("div", { className: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none left-0 top-0 bottom-0", "aria-hidden": "true" },
                React.createElement("svg", { className: "w-5 h-5 text-gray-400", fill: "currentColor", viewBox: "0 0 20 20" },
                    React.createElement("path", { fillRule: "evenodd", d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z", clipRule: "evenodd" }))),
            React.createElement("input", { className: "block w-full py-2 pl-10 pr-3 placeholder-gray-500 bg-white border border-transparent rounded-md leading-5 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo sm:text-sm transition duration-150 ease-in-out", placeholder: t('SEARCH'), type: "search", value: this.props.value, onChange: this.handleChange })));
    }
}
Search.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
export default withTranslation()(Search);
